import { EntityId, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { addFileAction, removeFileAction } from './actions';

export type FileModel = {
    id: string;
    refId?: string | number;
    fileName: string;
    fileSize: number;
    pagesIds: EntityId[];
};

const filesAdapter = createEntityAdapter<FileModel>({ selectId: model => model.id });

export const fileSlice = createSlice({
    name: 'files',
    initialState: filesAdapter.getInitialState(),
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(addFileAction, (state, action) => {
                filesAdapter.addOne(state, action.payload.file);
            })
            .addCase(removeFileAction, state => filesAdapter.removeAll(state));
    }
});
